module.exports = __webpack_public_path__ + "static/pic11-507e913b5bb43fb12ca84c8f8ed8c3aa.jpg";